import { InjectionToken } from '@angular/core';

export const DEMO_APARTMENTS = new InjectionToken<{ name: string; photoUrl: string; demoUrl: string }[]>('BASE_URL');
